const { viewportSize } = window.BAO.Utils

class ShoppableProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.trigger = ''

    this.isTouch = false
    this.mouseDown = false

    this.touchstartY = 0
    this.touchendY = 0
  }

  setupListeners () {
    super.setupListeners()

    this.setupModal = this.setupModal.bind(this)
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(window, `load`, this.setupModal)
    this.listeners.add(document, `click`, this.handleTrigger)
    this.els.close.elements.forEach(closeEl => {
      this.listeners.add(closeEl, `click`, this.handleClose)
    })

    this.listeners.add(document, 'drawerOpen', this.handleClose)

    this.detectTouch = this.detectTouch.bind(this)

    this.onTouchStart = this.onTouchStart.bind(this)
    this.onTouchMove = this.onTouchMove.bind(this)
    this.onTouchEnd = this.onTouchEnd.bind(this)

    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)

    if (this.els?.handle?.exists) {
      this.els.handle.elements.forEach(handle => {
        this.listeners.add(handle, 'touchstart', this.onTouchStart)
        this.listeners.add(handle, 'touchmove', this.onTouchMove)
        this.listeners.add(handle, 'touchend', this.onTouchEnd)

        this.listeners.add(handle, 'mousedown', this.onMouseDown)
        this.listeners.add(document, 'mousemove', this.onMouseMove)
        this.listeners.add(document, 'mouseup', this.onMouseUp)
      })
    }

    this.listeners.add(
      document.documentElement,
      'keydown',
      this.handleKeydown.bind(this),
    )
  }

  detectTouch () {
    this.isTouch = true
  }

  onTouchStart (event) {
    if (viewportSize() !== `xs`) return

    this.touchstartY = event.changedTouches[0].screenY

    this.setAttribute('drag', '')
  }

  onTouchMove (event) {
    if (viewportSize() !== `xs`) return

    const diffY = event.changedTouches[0].screenY - this.touchstartY

    if (diffY <= 0) return

    this.style.setProperty('--Drag', `${diffY}px`)
  }

  onTouchEnd (event) {
    if (viewportSize() !== `xs`) return

    this.touchendY = event.changedTouches[0].screenY

    this.style.setProperty('--Drag', `0px`)

    this.removeAttribute('drag')

    if (this.touchendY > this.touchstartY) {
      this.handleClose()
    }
  }

  onMouseDown (event) {
    if (viewportSize() !== `xs`) return

    if (this.isTouch === true) return

    this.mouseDown = true

    this.touchstartY = event.screenY

    this.setAttribute('drag', '')
  }

  onMouseMove (event) {
    if (viewportSize() !== `xs`) return

    if (this.isTouch === true) return

    if (this.mouseDown === false) return

    const diffY = event.screenY - this.touchstartY

    if (diffY <= 0) return

    this.style.setProperty('--Drag', `${diffY}px`)
  }

  onMouseUp (event) {
    if (viewportSize() !== `xs`) {
      this.handleClose()

      return
    }

    if (this.isTouch === true) return

    if (this.mouseDown === false) return

    this.mouseDown = false

    this.touchendY = event.screenY

    this.style.setProperty('--Drag', `0px`)

    this.removeAttribute('drag')

    if (this.touchendY > this.touchstartY) {
      this.handleClose()
    }
  }

  setupModal () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD,
      this.handleClose,
    )

    this.addEventListener(`click`, e => {
      if (e.target !== this) return

      this.setAttribute('aria-hidden', 'true')
    })
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-shoppable-products-external-el="trigger"]',
    )
    if (!trigger) return

    const productHandles = trigger.dataset.shoppableProductHandles?.split(',')
    if (!productHandles) return

    // Fetch product markup
    const productMarkup = await this.renderProductCards(productHandles)
    if (!productMarkup) return

    this.trigger = trigger

    // Add new product markup to content container
    this.els.content.element.innerHTML = productMarkup

    // Count number of cards and update attribute
    const cardCount = [
      ...this.els.content.element.querySelectorAll('.sp-ShoppableProducts_Card'),
    ].length
    this.els.content.element.dataset.cardCount = cardCount

    // Reveal content container
    this.els.content.element.setAttribute('aria-hidden', 'false')

    // Open modal
    window.drawers.activeDrawerKey = ''
    this.setAttribute('aria-hidden', 'false')
    this.fixBody()

    // Move focus to within drawer
    window.setTimeout(() => {
      const isButton =
        this.els.close?.element?.getAttribute('type') === 'button'
      const firstFocusable = this.els.content.element
        .querySelectorAll('a, button, input:not([type=hidden])')
        ?.item(1)

      if (isButton) {
        this.els.close.element.focus()
      } else if (firstFocusable) {
        firstFocusable.focus()
      }
    }, 500)
  }

  async renderProductCards (productHandles) {
    let productMarkup = ''

    try {
      const fetchPromises = productHandles.map(async (handle, index) => {
        const url = `/products/${handle}/?${new URLSearchParams({
          view: 'card',
        }).toString()}`
        return this.fetchProductCardMarkup(url)
      })

      const productCardMarkups = await Promise.all(fetchPromises)

      productCardMarkups.forEach(markup => {
        if (markup) {
          productMarkup += `
            <li class="sp-ShoppableProducts_Card">
              ${markup}
            </li>
          `
        }
      })

      return productMarkup
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async fetchProductCardMarkup (url) {
    try {
      const response = await fetch(url)
      return await response.text()
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  fixBody () {
    document.body.classList.add('util-SiteOverflowed')
  }

  releaseBody () {
    if (
      document.body.classList.contains('util-DrawersOpen') &&
      document.body.classList.contains('drw-Drawers-cart')
    ) {
      return
    }

    document.body.classList.remove('util-SiteOverflowed')
  }

  handleClose () {
    if (this.getAttribute('aria-hidden') !== 'true') {
      this.setAttribute('aria-hidden', 'true')

      this.releaseBody()

      if (this.trigger !== '') {
        this.trigger.focus()
      }

      this.triggerUrl = ''
    }
  }

  handleKeydown (e) {
    if (this.trigger === '') return

    if (e.key !== 'Escape') return

    this.handleClose()
  }
}

if (!customElements.get('shoppable-products')) {
  customElements.define('shoppable-products', ShoppableProducts)
}
